module.exports = __webpack_public_path__ + "static/img/brees-2017-top-image-thumb.20f5a7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2017-top-image-thumb.jpg
// module id = fok9
// module chunks = 1